<template>
  <div id="myerweima">
    <Modal v-model="openEr" footer-hide width="350" :styles="{ top: '20px' }">
      <Tabs :value="title" size="small" id="serclser">
        <TabPane
          :label="item.qrCodeTitle"
          :name="item.qrCodeTitle"
          v-for="(item, index) in eImg"
          :key="index"
        >
          <img :src="item.qrCodePic" width="320" />
          <p>{{ item.qrCodeDes }}</p>
        </TabPane>
      </Tabs>
    </Modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      openEr: false,
      eImg: [],
      title: "",
    };
  },
  methods: {
    open(v) {
      this.openEr = true;
      this.eImg = v;
      this.title = v[0].qrCodeTitle;
    },
  },
};
</script>
<style>
#myerweima {
  float: left;
  margin-top: 14px;
  margin-right: 14px;
}
#myerweima i {
  font-size: 22px;
  color: #fff;
  cursor: pointer;
}
#serclser .ivu-tabs-mini .ivu-tabs-tab {
  padding: 8px 8px;
}
#serclser .ivu-tabs-nav .ivu-tabs-tab {
  padding: 8px 8px;
}
</style>



// WEBPACK FOOTER //
// ../common/src/components/sys/erweima.vue